import CryptoJS from "crypto-js";

// Define the AES key as a constant. Ensure it is Base64-encoded.
// It should be the same key in Java as the SECRET_KEY field in RootController.
const SECRET_KEY = "ZMs1X4mbSopARLxp";

/**
 * Decrypts AES-encrypted text using crypto-js with ECB mode.
 *
 * @param {string} encryptedText - Base64-encoded encrypted text.
 * @returns {string} - Decrypted text.
 */
function decryptText(encryptedText) {
    try {
        // Decode the Base64-encoded encrypted text
        const encryptedBytes = CryptoJS.enc.Base64.parse(encryptedText);

        // Decrypt the text
        const decryptedBytes = CryptoJS.AES.decrypt({ ciphertext: encryptedBytes }, CryptoJS.enc.Utf8.parse(SECRET_KEY), {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7,
        });

        // Convert the decrypted bytes to a string
        return decryptedBytes.toString(CryptoJS.enc.Utf8);
    } catch (e) {
        console.error("Decryption failed:", e);
        return null;
    }
}

/**
 * Encrypts plain text using AES encryption with ECB mode.
 *
 * @param {string} plainText - The text to encrypt.
 * @returns {string} - Base64-encoded encrypted text.
 */
function encryptText(plainText) {
    try {
        // Encrypt the plain text with a properly parsed key
        const encryptedBytes = CryptoJS.AES.encrypt(plainText, CryptoJS.enc.Utf8.parse(SECRET_KEY), {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7,
        });

        // Convert the encrypted bytes to Base64
        return encryptedBytes.ciphertext.toString(CryptoJS.enc.Base64);
    } catch (e) {
        console.error("Encryption failed:", e);
        return null;
    }
}

/** Short unsubscribe token: first 8 bytes of HMAC-SHA256(email), hex (16 chars). */
function mailingVerifyCode(email) {
    const normalized = (email || "").trim().toLowerCase();
    if (!normalized) return "";
    const hmac = CryptoJS.HmacSHA256(normalized, SECRET_KEY);
    return hmac.toString(CryptoJS.enc.Hex).slice(0, 16);
}

function mailingVerifyCodeMatches(email, verifyCode) {
    const expected = mailingVerifyCode(email);
    const given = (verifyCode || "").trim().toLowerCase();
    return Boolean(expected && given && expected === given);
}

// Export the functions for use in other files
export { decryptText, encryptText, mailingVerifyCode, mailingVerifyCodeMatches };
